class AddedLabel {
    constructor(label, place, language) {
        this.label = label;
        this.place = place; // Place object (modified place)
        this.language = language; // Language object (selected language)
    }
}

export default AddedLabel;